export enum GlucoseLevelCode {
    NORMAL = "NORMAL",
    TARGET_RANGE = "TARGET_RANGE",
    VERY_HIGH = "VERY_HIGH",
    HIGH = "HIGH",
    LOW = "LOW",
    VERY_LOW = "VERY_LOW"
}

export const mapStringToLevelCode = (str: string): GlucoseLevelCode => {
    switch (str) {
        case "NORMAL": return GlucoseLevelCode.NORMAL;
        case "TARGET_RANGE": return GlucoseLevelCode.TARGET_RANGE;
        case "VERY_HIGH": return GlucoseLevelCode.VERY_HIGH;
        case "HIGH": return GlucoseLevelCode.HIGH;
        case "LOW": return GlucoseLevelCode.LOW;
        case "VERY_LOW": return GlucoseLevelCode.VERY_LOW;

    }
}

export interface IGlucoseLevels {
    level_code: GlucoseLevelCode,
    level_text: string,
    range_text: string,
    minimum: {
        value: number,
        unit: string
    },
    maximum: {
        value: number,
        unit: string
    },
    sort_order: number
}